//libs\core\shell\src\lib\layout\admin\components\shell-admin-header\shell-admin-header.component.ts
import { ChangeDetectionStrategy, Component, computed, Input, signal } from '@angular/core';
import { BreadcrumbItem } from '@cardapio-online/breadcrumb';

@Component({
  selector: 'lib-shell-admin-header',
  templateUrl: './shell-admin-header.component.html',
  styleUrl: './shell-admin-header.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellAdminHeaderComponent {
    private readonly breadcrumbsSignal = signal<BreadcrumbItem[]>([]);
    private readonly headerTitleSignal = signal('');
    private readonly headerUpperTitleSignal = signal('');
    private readonly headerSubtitleSignal = signal('');
    private readonly addActionLabelSignal = signal<string | null>(null);
    private readonly addActionRouteSignal = signal<string | unknown[] | null>(null);

    @Input()
    set addActionRoute(value: string | unknown[] | null | undefined) {
      this.addActionRouteSignal.set(value ?? null);
    }
    get addActionRoute(): string | unknown[] | null {
      return this.addActionRouteSignal();
    }
  
    protected readonly hasAddAction = computed(() => {
      return Boolean(this.addActionLabelSignal() && this.addActionRouteSignal());
    });


    @Input()
    set addActionLabel(value: string | null | undefined) {
      this.addActionLabelSignal.set(value ?? null);
    }
    get addActionLabel(): string | null {
     return this.addActionLabelSignal();
    }

    @Input()
    set headerSubtitle(value: string | null | undefined) {
      this.headerSubtitleSignal.set(value ?? '');
    }
    get headerSubtitle(): string {
      return this.headerSubtitleSignal();
    }

    @Input()
    set headerTitle(value: string | null | undefined) {
      this.headerTitleSignal.set(value ?? '');
    }
    get headerTitle(): string {
      return this.headerTitleSignal();
    }
    @Input()
    set headerUpperTitle(value: string | null | undefined) {
      this.headerUpperTitleSignal.set(value ?? '');
    }
    get headerUpperTitle(): string {
      return this.headerUpperTitleSignal();
    }

    @Input()
    set breadcrumbs(value: BreadcrumbItem[] | null | undefined) {
      this.breadcrumbsSignal.set(value ?? []);
    }
    get breadcrumbs(): BreadcrumbItem[] {
      return this.breadcrumbsSignal();
    }
}
